module.exports = __webpack_public_path__ + "img/logo_dna.ad817a68.png";